module.exports = __webpack_public_path__ + "static/media/01.6448e6eb.jpg";